import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Form, Select, FormInstance } from 'antd';
import { NamePath } from 'antd/lib/form/interface';
import classNames from 'classnames';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

import 'antd-multi-cascader/dist/index.css';

import { FilterTag } from './filter-tag';
import { Translations } from '../filter-bar-2';
import { FilterBar2Value } from '../types';
import Checkbox from 'components/checkbox/checkbox';

export interface SelectValue {
	label: string;
	value: any;
	children?: SelectValue;
}

export interface FilterContentSelectProps {
	name: NamePath;
	values?: FilterBar2Value[];
	multiselect?: boolean;
	placeholder?: string;
	className?: string;
	translations: Translations;
	onChange?: (value: any, option: any) => void;
	form: FormInstance;
}

export const FilterContentTeams = ({
	name,
	values,
	placeholder,
	multiselect,
	className,
	translations,
	onChange,
	form
}: FilterContentSelectProps) => {
	// the only way to make checkboxes be rendered with a actual value
	// easy can be refactored to one line with hook .useWatch from new atnd version
	const [currentValues, setCurrentValues] = useState([]);
	const selectedValues = form.getFieldValue(name);
	useEffect(() => {
		setCurrentValues(selectedValues);
	}, [selectedValues]);

	const onValueChange = (value, option) => {
		setCurrentValues(value);
		onChange(value, option);
	};

	const parentTeams = useMemo(() => values.filter(team => team.children?.length), [values]);
	const childTeams = useMemo(() => values.filter(team => !team.children?.length), [values]);

	const filterOption = useCallback((input, optionOrGroup) => {
		const isGroup = Array.isArray(optionOrGroup.options);
		if (isGroup) {
			return false;
		}
		return optionOrGroup.children[1].toLowerCase().includes(input.toLowerCase());
	}, []);

	const stopPropagationMouseDownEvent = useCallback((event: React.MouseEvent<HTMLSpanElement>) => {
		event.stopPropagation();
	}, []);

	return (
		<Form.Item name={name}>
			<Select
				allowClear
				showArrow
				className={className}
				mode={multiselect ? 'multiple' : undefined}
				showSearch
				filterOption={filterOption}
				placeholder={placeholder}
				suffixIcon={<BringgIcon className="filter-chevron-icon" iconName={BringgFontIcons.Chevron} />}
				tagRender={props => (
					<FilterTag
						closable
						reversed={false}
						onClose={props.onClose}
						onMouseDown={stopPropagationMouseDownEvent}
					>
						{values?.find(val => val.value === props.value)?.label}
					</FilterTag>
				)}
				onChange={onValueChange}
				popupClassName={classNames('filter-bar-select', { multiselect })}
			>
				{parentTeams.length ? (
					<>
						<Select.OptGroup label={translations.teams}>
							{parentTeams.map(item => (
								<Select.Option value={item.value} key={item.value}>
									{multiselect && (
										<Checkbox
											checked={Boolean(currentValues?.find(value => value === item.value))}
										/>
									)}
									{item.label}
								</Select.Option>
							))}
						</Select.OptGroup>
						<Select.OptGroup label={translations.subTeams}>
							{childTeams.map(item => (
								<Select.Option value={item.value} key={item.value}>
									{multiselect && (
										<Checkbox
											checked={Boolean(currentValues?.find(value => value === item.value))}
										/>
									)}
									{item.label}
								</Select.Option>
							))}
						</Select.OptGroup>
					</>
				) : (
					values.map(item => (
						<Select.Option value={item.value} key={item.value}>
							{multiselect && (
								<Checkbox checked={Boolean(currentValues?.find(value => value === item.value))} />
							)}
							{item.label}
						</Select.Option>
					))
				)}
			</Select>
		</Form.Item>
	);
};
